

import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import "./style/global.css";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import { MaterialUIControllerProvider } from "context";

ReactDOM.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <App />
      <ToastContainer rtl/>
    </MaterialUIControllerProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
serviceWorkerRegistration.register();
